export const I_DONT_KNOW = 'I don\'t know';